import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import CategoriesFilter from "./CategoriesFilter";
import ArticleListItem from "./ArticleListItem";
import "../../styles/BlogListSection.css";

const BlogListSection = ({ posts = [], limit = 20 }) => {
  const [filtered, setFiltered] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  // Static filter buttons
  // const categories = ["All", "Technology", "AI", "Tools", "AI Tools", "Future"];

  // Initialize filtered posts
  useEffect(() => {
    if (!posts || posts.length === 0) return;
    setFiltered(posts);
  }, [posts, limit]);

  // Apply category filter
  useEffect(() => {
    if (!posts || posts.length === 0) return;

    if (activeCategory === "All") {
      setFiltered(posts);
    } else {
      setFiltered(
        posts.filter(
          (p) =>
            (p?.category?.name || p?.category || "")
              .toString()
              .toLowerCase() === activeCategory.toLowerCase(),
        ),
      );
    }
  }, [activeCategory, posts]);

  if (!posts || posts.length === 0) return null;

  return (
    <section className="bls-section" aria-labelledby="bls-heading">
      <Container fluid="lg">
        <Row className="align-items-center bls-header text-muted">
          <Col md={8}>
            <div className="bls-pill small text-secondary">
              Stories from Our Work
            </div>
            <h2 id="bls-heading" className="bls-title">
              Builder’s Perspective
            </h2>
          </Col>

          <Col md={4} className="text-md-end">
            <button
              className="btn-secondary bls-viewall"
              aria-label="View all news"
            >
              View All Blogs ↗
            </button>
          </Col>
        </Row>

        {/*
<Row className="mt-4">
  <Col xs={12}>
    <CategoriesFilter
      categories={categories}
      active={activeCategory}
      onChange={(c) => setActiveCategory(c)}
    />
  </Col>
</Row>
*/}

        <div className="bls-divider" />

        <Row className="mt-4">
          <Col xs={12}>
            {filtered.length === 0 ? (
              <div className="bls-empty">No articles found.</div>
            ) : (
              filtered.map((post) => (
                <ArticleListItem key={post._id || post.slug} post={post} />
              ))
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BlogListSection;
